import Shepherd, {Tour} from 'shepherd.js';
import { offset } from '@floating-ui/dom';

function shepherdBackButton(tour: Tour) {
    return {
        action() { return tour.back(); },
        classes: 'shepherd-button-secondary',
        text: 'Back'
    };
}

function shepherdNextButton(tour: Tour) {
    return {
        action() { return tour.next(); },
        classes: 'shepherd-button-secondary',
        text: 'Next'
    };
}

function shepherdFinishButton(tour: Tour) {
    return {
        action() { return tour.hide(); },
        classes: 'shepherd-button-secondary',
        text: 'Close'
    };
}

function queryElement(parent: HTMLElement, selector: string) : HTMLElement | null {
    return parent.querySelector<HTMLElement>(selector);
}

export class SegmentChecksTour {

    static currentTour: Tour | null = null;

    static startTour(tour: Tour) {
        if (this.currentTour) {
            this.currentTour.cancel();
        }
        this.currentTour = tour;
        tour.start();
    }

    static async startSegmentTour(parentElement: HTMLElement) {
        const tour = new Shepherd.Tour({
            defaultStepOptions: {
                cancelIcon: {
                    enabled: true
                },
                classes: 'class-1 class-2',
                scrollTo: { behavior: 'smooth', block: 'center' }
            }
        });

        tour.addStep({
            title: 'Check Summary',
            text: 'This section provides a summary of the checks for the segment, including the total number of checks and their overall status.',
            attachTo: {
                element: queryElement(parentElement, '.check-summary'),
                on: 'bottom'
            },
            extraHighlights: ['.check-summary'],
            buttons: [shepherdNextButton(tour)],
            id: 'overview'
        });

        tour.addStep({
            title: 'Table with Check Summary',
            text: 'This table provides a detailed list of the checks for the segment.',
            attachTo: {
                element: queryElement(parentElement, '.checks-table'),
                on: 'top'
            },
            buttons: [shepherdBackButton(tour), shepherdNextButton(tour)],
            id: 'checks-table'
        });

        tour.addStep({
            title: 'Global Period Filters',
            text: 'You can filter the checks by period to see only the checks for a specific time range.',
            attachTo: {
                element: '.app-period-filter-label',
                on: 'bottom'
            },
            floatingUIOptions: {
                middleware: [offset({ mainAxis: 20, crossAxis: 0 })]
            },
            buttons: [shepherdBackButton(tour), shepherdFinishButton(tour)],
            id: 'checks-table'

        });

        return SegmentChecksTour.startTour(tour);
    }
}
